var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCatDeleteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1621,
    cy: 24.7285,
    r: 24,
    fill: "#CD4B32",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1621 20.7285V26.7285",
    stroke: "#D25D47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4311 13.7266L11.4341 32.7256C11.2581 33.0296 11.1653 33.3746 11.165 33.7259C11.1647 34.0772 11.257 34.4223 11.4324 34.7266C11.6079 35.0309 11.8604 35.2836 12.1646 35.4593C12.4687 35.635 12.8138 35.7276 13.165 35.7276H35.1591C35.5104 35.7276 35.8554 35.6351 36.1596 35.4593C36.4637 35.2836 36.7163 35.0309 36.8917 34.7266C37.0672 34.4223 37.1594 34.0772 37.1591 33.7259C37.1588 33.3746 37.066 33.0296 36.8901 32.7256L25.893 13.7266C25.7173 13.4231 25.4649 13.1711 25.1611 12.9959C24.8573 12.8207 24.5128 12.7285 24.1621 12.7285C23.8114 12.7285 23.4668 12.8207 23.163 12.9959C22.8592 13.1711 22.6068 13.4231 22.4311 13.7266V13.7266Z",
    stroke: "#D25D47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1621 32.7285C24.9905 32.7285 25.6621 32.0569 25.6621 31.2285C25.6621 30.4001 24.9905 29.7285 24.1621 29.7285C23.3337 29.7285 22.6621 30.4001 22.6621 31.2285C22.6621 32.0569 23.3337 32.7285 24.1621 32.7285Z",
    fill: "#D25D47"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatDeleteIc);
export default __webpack_public_path__ + "static/media/CatDeleteIc.9d2dc00f2552e9f53026b6d6b2f8f485.svg";
export { ForwardRef as ReactComponent };